import './_size-guide-pdp-modal.scss';
import component from './size-guide-pdp-modal';

export default component;
